import { render, staticRenderFns } from "./Naw3.vue?vue&type=template&id=706e0198&scoped=true&"
import script from "./Naw3.vue?vue&type=script&lang=js&"
export * from "./Naw3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706e0198",
  null
  
)

export default component.exports